module.exports = __webpack_public_path__ + "img/eth-foundation.3ad09334.svg";